<script>
import {
  CdrButton,
  CdrImg,
  CdrText,
} from '@rei/cedar';
import EditorsChoiceBadge from '../utils/SVGs/EditorsChoiceBadge.vue';

export default {
  name: 'EditorsChoiceBanner',
  components: {
    CdrButton,
    CdrImg,
    CdrText,
    EditorsChoiceBadge,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    imageDesktop: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    baseClassName: 'ea-editors-choice-banner',
  }),
};
</script>

<template>
  <div :class="`${baseClassName}`">
    <div :class="`${baseClassName}__container`">
      <editors-choice-badge :class="`${baseClassName}__ea_badge`" />
      <div :class="`${baseClassName}__content`">
        <cdr-text
          :class="`${baseClassName}__header`"
          tag="h2"
        >
          {{ header }}
        </cdr-text>
        <cdr-text :class="`${baseClassName}__text`">
          {{ body }}
        </cdr-text>
        <cdr-button
          :class="`${baseClassName}__button`"
          tag="a"
          href="/learn/expert-advice/rei-editors-choice-awards.html"
          modifier="primary"
          data-analytics-id="editors_choice_banner"
        >
          {{ buttonText }}
        </cdr-button>
      </div>
      <div :class="`${baseClassName}__background_image`">
        <cdr-img
          :class="`${baseClassName}__mobile`"
          :src="imageMobile"
          alt=""
        />
        <cdr-img
          :class="`${baseClassName}__desktop`"
          :src="imageDesktop"
          ratio="auto"
          cover
          crop="bottom left"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

@import '@rei/cdr-component-variables/dist/scss/cedar-component-variables.scss';
$baseClassName: 'ea-editors-choice-banner';

.#{$baseClassName} {
  @include cdr-container;

  .#{$baseClassName}__container {
    background-color: #A3E8E5;
    display: flex;
    position: relative;
    border-radius: $cdr-radius-softer;

    flex-direction: column;
    @include cdr-sm-mq-up {
      flex-direction: row;
    }

  }

  .#{$baseClassName}__background_image {
    flex: 1 1 auto;
    margin: auto;
    position: relative;
  }
  .#{$baseClassName}__mobile {
    display: block;
    position: initial;
    width: 100%;

    @include cdr-sm-mq-up {
      display: none;
    }
  }
  .#{$baseClassName}__desktop {
    display: none;

    @include cdr-sm-mq-up {
      display: block;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }

  .#{$baseClassName}__ea_badge {
    @include cdr-xs-mq-only {
      position: absolute;
      height: 32vw;
      width: 32vw;
      right: 6vw;
      bottom: 40vw;;
    }
    @include cdr-sm-mq-up {
      margin: $cdr-space-two-x;
      flex: 0 0 16%;
    }
    @include cdr-md-mq-up {
      margin: $cdr-space-two-x;
      flex: 0 0 12%;
    }
  }

  .#{$baseClassName}__content {
    @include cdr-xs-mq-only {
      margin: $cdr-space-two-x;
    }
    @include cdr-sm-mq-up {
      flex: 0 0 40%;
      margin: $cdr-space-two-x 0;
    }
    @include cdr-md-mq-up {
      flex: 0 0 42%;
    }
  }
  .#{$baseClassName}__header {
    @include cdr-text-heading-serif-800;
      margin: 0 0 $cdr-space-one-and-a-half-x 0;
    @include cdr-md-mq-up {
      margin: $cdr-space-one-and-a-half-x 0;
    }
  }
  .#{$baseClassName}__text {
    @include cdr-text-utility-sans-300;
    margin: $cdr-space-one-x 0;
  }
  .#{$baseClassName}__button {
    @include cdr-button-base-mixin;
    @include cdr-button-primary-mixin;
  }

}
</style>
